import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ModuleListModel } from 'app/module/models/module-list.model';
import { ModuleService } from 'app/module/services/module.service';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-module-list',
    templateUrl: './module-list.component.html',
    styleUrls: ['./module-list.component.css']
})
export class ModuleListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    modules: ModuleListModel[];
    moduleList: ModuleListModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private moduleService: ModuleService,
        private fb: FormBuilder,
        private sortService: SortService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Modules' }

        this.moduleService.getAll().subscribe(
            modules => {
                this.modules = modules;
                this.moduleList = modules;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.moduleList = this.sortService.filterAndSortlist(this.modules, newValue, this.lastSort);
        });
    }
}
